import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { FeesCard } from "./FeesCard";
import { Col, Row, Spinner } from "react-bootstrap";
import "./Fees.scss";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFees,
  feesList,
  setCurrentData,
} from "../../../redux/actions/dbactions/feesActions";
import { EditModal } from "./EditModal";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

// Add searchQuery as a prop if it's passed from a parent component
const Fees = ({ searchQuery = "" }) => {
  const dispatch = useDispatch();
  const { fees, isLoading } = useSelector((state) => state.feeslist);
  const [show, setShow] = useState(false);
  const [editmodal, setEditmodal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  useEffect(() => {
    dispatch(feesList());
    dispatch(refTypesList());
  }, [dispatch, refresh]);

  const values = Object.values(fees?.usr?.rec || []);
  const filteredValues = values.filter((item) =>
    item.svcfee_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleShow = (svcfee_id, svcfee_name) => {
    setShow(true);
    setSelectedId(svcfee_id);
    setSelectedTitle(svcfee_name);
  };

  const handleEditModal = (data) => {
    setEditmodal(true);
    dispatch(setCurrentData(data));
    setSelectedCountryId(data.svcfee_svcf_iso_cntry_id);
  };

  const handleDelete = () => {
    if (selectedId) {
      dispatch(deleteFees(selectedId));
      setRefresh(true);
      setShow(false);
    }
  };

  return (
    <div>
      <Header
        pageTitle="Fees"
        icon={<Icon icon="fa-solid:money-bill-wave" />}
      />
      <div className="ser_title_b px-[0.75rem] sm:px-8 mt-3">
        <h5 className="title">Fees List</h5>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row className="sm:px-4 m-0">
          {filteredValues.length > 0 ? (
            filteredValues.map((item) => (
              <Col className="mb-3" md={4} sm={6} key={item.svcfee_id}>
                <FeesCard
                  data={item}
                  dispatch={dispatch}
                  handleShow={() =>
                    handleShow(item.svcfee_id, item.svcfee_name)
                  }
                  handleEditModal={() => handleEditModal(item)}
                />
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center">No Fees found</p>
            </Col>
          )}
        </Row>
      )}
      <DeleteModal
        handleDelete={handleDelete}
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        dispatch={dispatch}
        selectedCountryId={selectedCountryId}
        setSelectedCountryId={setSelectedCountryId}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
      />
    </div>
  );
};

export default withRouter(Fees);
